"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const errors_1 = require("./errors");
class Method {
    constructor({ name, params, noRetry, asyncCallback, onResultReceived, cb }) {
        this.name = name;
        this.params = params;
        this.noRetry = noRetry;
        this.asyncCallback = asyncCallback;
        this.onResultReceived = onResultReceived;
        this.dataVisible = false;
        this.methodResult = null;
        this.wasCanceled = false;
        this.setCallback(cb);
    }
    maybeInvokeCallback() {
        if (this.methodResult && this.dataVisible) {
            this.cb(...this.methodResult);
        }
    }
    result({ error, result }) {
        if (this.wasCanceled) {
            return;
        }
        if (this.methodResult) {
            console.warn('Methods should only receive result once');
            return;
        }
        this.methodResult = [
            error && new errors_1.DDPError(error.error, error.reason, error.details),
            result,
        ];
        if (this.onResultReceived) {
            this.onResultReceived(...this.methodResult);
        }
        this.maybeInvokeCallback();
    }
    updated() {
        if (this.wasCanceled) {
            return;
        }
        if (this.dataVisible) {
            console.warn('Method received "updated" message twice');
            return;
        }
        this.dataVisible = true;
        this.maybeInvokeCallback();
    }
    cancel(err) {
        this.wasCanceled = true;
        this.cb(err || new errors_1.DDPCancel(`Method ${this.name} was canceled`));
    }
    setCallback(cb) {
        this.cb = (0, utils_1.once)((...args) => {
            if (cb) {
                cb(...args);
            }
            if (this.asyncCallback) {
                this.asyncCallback(...args);
            }
        });
    }
    toDDPMessage(id) {
        const { name, params } = this;
        return {
            id,
            params,
            method: name,
            msg: 'method',
        };
    }
}
exports.default = Method;
//# sourceMappingURL=Method.js.map